import { forwardQuery } from './aspects/forwardQuery.js';
export function useAspects() {
    return useAspects._impl();
}
useAspects._impl = () => ({
    forwardQuery,
});
useAspects.setup = (impl) => {
    useAspects._impl = impl;
};
//# sourceMappingURL=useAspects.js.map